
import { FormPage } from "../../types/form";

export const page4Config: FormPage = {
  page: 4,
  elements: [
    {
      id: "section_teaching_materials",
      type: "section_header",
      label: "formFields.page4.sectionMaterials"
    },
    {
      id: "worksheet_upload",
      type: "file",
      label: "formFields.page4.worksheetUploadLabel",
      name: "worksheet_urls",
      required: false,
      description: "formFields.page4.worksheetUploadDesc",
      validation: {
        maxFiles: 1,
        maxSizeMB: 50
      }
    },
    {
      id: "worksheet_links",
      type: "document_link",
      label: "formFields.page4.worksheetLinksLabel",
      name: "document_links",
      required: false,
      description: "formFields.page4.worksheetLinksDesc"
    },
    {
      id: "drive_link",
      type: "url",
      label: "formFields.page4.driveLinkLabel",
      name: "worksheet_drive_link",
      required: false
    },
    {
      id: "final_check_instruction",
      type: "instruction",
      text: "formFields.page4.finalCheckInstruction"
    }
  ]
};
